import { Toast } from './Toast';

// TODO: in v9, move styled() from Toast.jsx to here
export var StyledToast = Toast;